export default {

  apiEndpoint: 'https://medreleaf-altavie.cdn.prismic.io/api/v2',

  // -- Access token if the Master is not open
  // accessToken: 'xxxxxx',

  // OAuth
  // clientId: 'xxxxxx',
  // clientSecret: 'xxxxxx',

  // -- Links resolution rules
  // This function will be used to generate links to Prismic.io documents
  // As your project grows, you should update this function according to your routes
  linkResolver(doc) {
    if (doc.type === 'general_page' || doc.type === 'our_strains_page' || doc.type === 'faq_page' || doc.type === 'contact_page' || doc.type === 'where_page' || doc.type === 'error_page') return `/${doc.uid}`
    else if (doc.type === 'product_page' && doc.lang === 'en-ca') return `/our-strains/${doc.uid}`
    else if (doc.type === 'product_page' && doc.lang === 'fr-ca') return `/nos-souches/${doc.uid}`
    return '/'
  },
};



// WEBPACK FOOTER //
// ./src/config/prismic.js